import React from 'react';
import { IconProps } from '.';

const SvgCreditCardFill = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M1.5 4.65c0-.58.47-1.05 1.05-1.05h18.9c.58 0 1.05.47 1.05 1.05v12.6a3.15 3.15 0 0 1-3.15 3.15H4.65a3.15 3.15 0 0 1-3.15-3.15V9.9h21V7.8h-21V4.65Zm4.2 8.4c0-.58.47-1.05 1.05-1.05H9.9a1.05 1.05 0 1 1 0 2.1H6.75c-.58 0-1.05-.47-1.05-1.05Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgCreditCardFill;
